/**
 * Typed PostHog event-name constants for the signup funnels (T2).
 *
 * These MUST match APPENDIX-data-and-events.md §B exactly — a typo here
 * silently breaks the funnel definitions in T4/T8. Import these constants
 * instead of writing event-name string literals at call sites.
 */

export const AnalyticsEvents = {
  // Worker signup funnel (frontend steps 1–3; step 4 is server-side, T3).
  WORKER_SIGNUP_STARTED: "worker_signup_started",
  WORKER_SIGNUP_ACCOUNT_CREATED: "worker_signup_account_created",
  WORKER_PROFILE_COMPLETED: "worker_profile_completed",

  // Employer signup funnel (frontend steps 1–3; step 4 is server-side, T3).
  EMPLOYER_SIGNUP_STARTED: "employer_signup_started",
  EMPLOYER_SIGNUP_ACCOUNT_CREATED: "employer_signup_account_created",
  EMPLOYER_BUSINESS_CREATED: "employer_business_created",
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

type SignupRole = "worker" | "employer";

/** Per-role `_started` event name. */
export function signupStartedEvent(role: SignupRole): AnalyticsEventName {
  return role === "employer"
    ? AnalyticsEvents.EMPLOYER_SIGNUP_STARTED
    : AnalyticsEvents.WORKER_SIGNUP_STARTED;
}

/** Per-role `_account_created` event name. */
export function signupAccountCreatedEvent(role: SignupRole): AnalyticsEventName {
  return role === "employer"
    ? AnalyticsEvents.EMPLOYER_SIGNUP_ACCOUNT_CREATED
    : AnalyticsEvents.WORKER_SIGNUP_ACCOUNT_CREATED;
}

/**
 * Per-role step-3 event name (worker profile details / employer business
 * details submitted).
 */
export function signupDetailsCompletedEvent(
  role: SignupRole,
): AnalyticsEventName {
  return role === "employer"
    ? AnalyticsEvents.EMPLOYER_BUSINESS_CREATED
    : AnalyticsEvents.WORKER_PROFILE_COMPLETED;
}
